import React from 'react'

import Table from '../../../../../UI/Table/Table'
import { Add, Edit, Delete } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import { memo } from 'react'

const dataTable = ({
  translate,
  recordData,
  structureName,
  structureType,
  addButtonClicked,
  editButtonClicked,
  deleteButtonClicked,
  addDisabled,
  editDisabled,
  deleteDisabled,
  loading
}) => {
  const qualityTableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'item_code', title: translate('itemCode'), type: 'string', width: '10%' },
    {
      field: 'item_name',
      title: translate('appraisalItemName'),
      type: 'string',
      render: rowData => {
        return (
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: 550
            }}>
            {rowData.item_name}
          </div>
        )
      }
    },
    {
      field: 'competency_name',
      title: translate('competencyName'),
      type: 'string'
    },
    { field: 'effective_date', title: translate('effectiveDate'), type: 'string', width: '12%' }
  ]

  const quantityTableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'perspective_name', title: translate('perspective'), type: 'string' },
    { field: 'item_code', title: translate('itemCode'), type: 'string', width: '15%' },
    {
      field: 'item_name',
      title: translate('appraisalItemName'),
      type: 'string',
      width: '40%',
      render: rowData => {
        return (
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: 550
            }}>
            {rowData.item_name}
          </div>
        )
      }
    },
    { field: 'effective_date', title: translate('effectiveDate'), type: 'string', width: '15%' }
  ]

  const deductTableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'item_name', title: translate('deductName'), type: 'string' },
    {
      field: 'max_value',
      title: translate('maxValue'),
      type: 'numeric',
      render: rowData => (rowData.max_value ? parseFloat(rowData.max_value)?.toFixed(2) : '')
    },
    {
      field: 'unit_deduct_score',
      title: translate('deductScoreUnit'),
      type: 'numeric',
      render: rowData =>
        rowData.unit_deduct_score ? parseFloat(rowData.unit_deduct_score)?.toFixed(2) : ''
    },
    {
      field: 'value_get_zero',
      title: translate('valueGetZero'),
      type: 'numeric',
      render: rowData =>
        rowData.value_get_zero ? parseFloat(rowData.value_get_zero)?.toFixed(2) : ''
    },
    { field: 'effective_date', title: translate('effectiveDate'), type: 'string', width: '15%' }
  ]

  const tableStructures = {
    STT01: quantityTableStructure,
    STT02: qualityTableStructure,
    STT03: deductTableStructure,
    STT04: quantityTableStructure,
    STT05: qualityTableStructure,
    STT06: qualityTableStructure
  }

  const rowActions = [
    {
      icon: () => <Add />,
      tooltip: translate('add'),
      onClick: addButtonClicked,
      isFreeAction: true,
      disabled: addDisabled
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: translate('edit'),
      onClick: (event, selectedRecord) => editButtonClicked(selectedRecord.item_id),
      disabled: editDisabled
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: translate('delete'),
      onClick: (event, selectedRecord) => deleteButtonClicked(selectedRecord.item_id),
      disabled: deleteDisabled
    }
  ]

  let tableStructure = tableStructures[structureType] || quantityTableStructure

  return (
    <Table
      alignLeft
      paginationDisabled={true}
      rowActions={rowActions}
      title={structureName}
      recordData={recordData}
      structure={tableStructure}
      loading={loading}
    />
  )
}

export default withTranslate(memo(dataTable))
